import {defineStore} from "pinia";
import {LISTINGS_SERVICE} from "~/data/ServicesConstants";

export const useCarDataStore = defineStore('car-data-store', () => {
    const carData = ref([])
    const getMakes = computed(() => {
        return [...new Set(carData.value?.map((car: any) => car.make))]
    })

    function getModelByMake(make: string) {
        return [...new Set(carData.value?.filter((car: any) => car.make === make).filter((car: any) => !!car.model && car.model !== '').map((car: any) => car.model))]
    }

    function fetchCarData() {
        const apiUrl: string = useNuxtApp().$getApiUrl(LISTINGS_SERVICE)
        $fetch<any>(apiUrl + '/v2/public/filters/cars/data').then((response: any) => {
            carData.value = response.filter((car: any) => car.make !== null && car.make !== '')
        }).catch((error: any) => console.log(error))
    }


    onMounted(() => {
        fetchCarData()
    })

    return {
        getMakes,
        getModelByMake
    }


})